import type { CareStateRequestStatusT } from '@lotushealth/lotushealth_js_sdk/schemas';

export type RequestTabId = 'active' | 'resolved' | 'actions';

export function isRequestVisibleInTab(status: CareStateRequestStatusT, tab: RequestTabId): boolean {
  switch (tab) {
    case 'active':
      return status === 'Open' || status === 'Pending Follow Up';
    case 'resolved':
      return status === 'Resolved' || status === 'Cancelled';
    case 'actions':
      return false;
    default: {
      const _exhaustive: never = tab;
      return _exhaustive;
    }
  }
}
